import { Router } from '@angular/router';
import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../auth.service';
import { ProductService } from '../services/product.service';
import { UserService } from '../services/user.service';
import { Product } from '../models/product';
import { User, CartItem, Order } from '../models/user';
import { Subscriber } from 'rxjs/Subscriber';
import { FirebaseApp } from 'angularfire2';
import { AngularFireAuth } from 'angularfire2/auth';

declare let paypal: any;

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements AfterViewChecked {

    //CART STUFF
    userOrder: Order = { uid:"", OItems:[], Status:"", Done:false };
    tempProduct: Product;
    nothing: number = 0.01;
    userCart: CartItem[];
    tempID: string;
    tempSize: string;
    tempQuant: number;
    tempStock: Array<number>;
    tempSizes: Array<string>;
    cartInfo: CartItem = { Name:"", URL:"", Category:"", Size:"", Price: 0, Quantity: 0, TPrice:0 };
    cartItems: CartItem[] = [];
    totalPrice: number = 0;

    //products_: Product[];

  //PAYPAL INTEGRATION
  addScript: boolean = false;
  paypalLoad: boolean = true;

  finalAmount: number = 1;

  paypalConfig = {
    env:'sandbox',
    client: {
        sandbox: 'ASCNjm2T9LGu2bYjbuyQyvkxmVHzXrds6Q_zODZuTOHBgx37cDqp59ytRFAvvAys98kHL54sIsGG4o9K',
        production: '<production-id-here>'
    },
    style: {
        label: 'paypal',
        size:  'medium',    // small | medium | large | responsive
        shape: 'rect',     // pill | rect
        color: 'blue',     // gold | blue | silver | black
        tagline: false
    },
    commit: true,
    payment: (data, actions) => {
        return actions.payment.create({
            payment:{
                transactions: [
                    //{amount: {total: this.totalPrice, currency: 'CAD'}}
                    {amount: {total: this.nothing, currency: 'CAD'}}
                ]
            }
        });
    },
    onAuthorize: (data, actions) => {
        return actions.payment.execute().then((payment) => {
            //console.log(Pay)
            this.makeOrder()
            this.updateStock()
            this.alertBox()
            this.router.navigate(['/'])
            this.emptyCart()
            
            //do something when payment is successful
        })
    }
  };

  ngAfterViewChecked(): void{
    if(!this.addScript){
        this.addPaypalScript().then(() => {
            paypal.Button.render(this.paypalConfig, '#paypal-checkout-btn');
            this.paypalLoad = false;
        })
    }
  };

  addPaypalScript(){
      this.addScript = true;
      return new Promise((resolve, reject) => {
          let scriptagElement = document.createElement('script');
          scriptagElement.src = "https://www.paypalobjects.com/api/checkout.js";
          scriptagElement.onload = resolve;
          document.body.appendChild(scriptagElement);
      })
  };


  constructor(private authService: AuthService, private userService: UserService, private router: Router, private productService: ProductService) {
    console.log(authService.currentUserId);
   }


    alertBox(){
    window.alert("Payment Success!");
   }

    makeOrder(){
    this.userOrder.uid = this.authService.currentUserId.toString();
    this.userOrder.Done = false;
    this.userOrder.Status = "Order sent to Clayson!";
    this.userOrder.OItems = this.cartItems;
    this.userService.addOrder(this.userOrder);
   }

  displayC(){
    this.cartItems = [];
    this.totalPrice = 0;
    this.userService.getUser(this.authService.currentUserId).subscribe(user => {
        this.cartItems = [];
        this.totalPrice = 0;
        for (var i = 0; i < user.Cart.length; i++){
            this.cartInfo = user.Cart[i];
            this.totalPrice += user.Cart[i].TPrice;
            this.cartItems.push(this.cartInfo);
        }
    });
  }

  deleteItem(value){
    this.cartItems.splice(value, 1);
    this.userService.addCart(this.cartItems, this.authService.currentUserId);
    this.displayC();
  }


  addItem(value){
    if (this.cartItems[value].Quantity < 5){
    this.cartItems[value].Quantity += 1;
    this.cartItems[value].TPrice = this.cartItems[value].Price * this.cartItems[value].Quantity;
    this.userService.addCart(this.cartItems, this.authService.currentUserId);
    this.displayC();
    }
  }

  decreaseItem(value){
    if (this.cartItems[value].Quantity > 1){
    this.cartItems[value].Quantity -= 1;
    this.cartItems[value].TPrice = this.cartItems[value].Price * this.cartItems[value].Quantity;
    this.userService.addCart(this.cartItems, this.authService.currentUserId);
    this.displayC();
    }
  }

  updateStock(){
    console.log(this.cartItems);
    for (var i = 0; i < this.cartItems.length; i++){
        this.tempID = this.cartItems[i].ProdID;
        this.tempQuant = this.cartItems[i].Quantity;
        this.tempSize = this.cartItems[i].Size;
        this.tempStock = [];
        const tProd = this.productService.getProduct(this.cartItems[i].ProdID).subscribe(item => {
            /*for (var j = 0; j < item.Stock.length; j++){
                this.tempStock.push(item.Stock[j]);
            }*/
            this.tempStock = item.Stock;
            //console.log(this.tempStock);
            for (var k = 0; k < this.tempStock.length; k++){
                if (this.tempSize == item.Sizes[k]){
                    this.tempStock[k] -= this.tempQuant;
                    console.log(this.tempStock);
                }
            }
            tProd.unsubscribe();
        });
        //this.productService.editStock(this.tempStock, this.tempID);
        console.log(this.tempStock);
    }
  }

  emptyCart(){
    this.cartItems = [];
    this.userService.addCart(this.cartItems, this.authService.currentUserId);
  }
}



// WEBPACK FOOTER //
// ./src/app/cart/cart.component.ts